@switch (view) {
    @case ('Pair') {
        <ms-inline-tooltip applyClass="left-nav-event-name">
            <div class="participants-pair-game">
                @for (participant of event.participants; track participant.id) {
                    <div #tooltipContent class="participant">
                        <ms-tree-participant [event]="event" [participant]="participant"></ms-tree-participant>
                    </div>
                }
            </div>
        </ms-inline-tooltip>
    }
    @case ('Tournament') {
        <ms-inline-tooltip applyClass="left-nav-event-name">
            <div class="participants-tournament-game">
                <div #tooltipContent class="tournament">{{ event.name }}</div>
                @if (leader) {
                    <div #tooltipContent class="tournament tournament-leader">
                        <ms-tree-participant [event]="event" [participant]="event.participants[0]"></ms-tree-participant>
                    </div>
                }
            </div>
        </ms-inline-tooltip>
    }
    @case ('Combi') {
        <ms-inline-tooltip applyClass="left-nav-event-name">
            <div class="participants-combi-game">
                <div #tooltipContent class="combi-league combi-league-name">{{ event.name }}</div>
                <div class="combi-league combi-league-option">{{ option }}</div>
            </div>
        </ms-inline-tooltip>
    }
}
